import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DesktopFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DesktopFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M19 1.5H5c-2.21 0-4 1.79-4 4V14c0 2.21 1.79 4 4 4h5.5v1.5H8v3h8v-3h-2.5V18H19c2.21 0 4-1.79 4-4V5.5c0-2.21-1.79-4-4-4ZM20 14c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V5.5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1V14Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DesktopFilled;